var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TeamTable',{attrs:{"isEditable":_vm.isUserAdminOnCompany,"members":_vm.members,"title":_vm.title},on:{"edit-member-role":_vm.editMemberRole,"delete-member":_vm.deleteMember,"invite-members":_vm.inviteMembers}})
}
var staticRenderFns = []

export { render, staticRenderFns }